export default __webpack_public_path__ + "static/media/SG11.6fa72992.webp";